import React, { Component } from 'react'
import { connect } from 'react-redux'
import { actualizarDatosParaMuiTable } from '../actions/TablaPedidoCamionesEnPlayaActions'
import { TablaPedidoCamionesEnPlayaView } from '../components/TablaPedidoCamionesEnPlayaView'

class TablaPedidoCamionesEnPlaya extends Component {
  componentDidMount () {
    this.props.actualizarDatosParaMuiTable()
  }

  render () {
    return <TablaPedidoCamionesEnPlayaView />
  }
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}
const withRedux = connect(null, mapActionsToProps)
export default withRedux(TablaPedidoCamionesEnPlaya)
